import { render, staticRenderFns } from "./ReportPhotoWorkEvidence.vue?vue&type=template&id=45807d04&"
import script from "./ReportPhotoWorkEvidence.vue?vue&type=script&lang=js&"
export * from "./ReportPhotoWorkEvidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports